var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMentionsAll = function SvgMentionsAll(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#50BA4D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12820_70741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 17.95C25 18.4 24.1 18.7 23.05 18.85C22.375 17.575 21.025 16.6 19.45 15.925C19.6 15.7 19.75 15.55 19.9 15.325H20.5C22.825 15.25 25 16.675 25 17.95ZM12.1 15.25H11.5C9.175 15.25 7 16.675 7 17.95C7 18.4 7.9 18.7 8.95 18.85C9.625 17.575 10.975 16.6 12.55 15.925L12.1 15.25ZM16 16C17.65 16 19 14.65 19 13C19 11.35 17.65 10 16 10C14.35 10 13 11.35 13 13C13 14.65 14.35 16 16 16ZM16 16.75C12.925 16.75 10 18.7 10 20.5C10 22 16 22 16 22C16 22 22 22 22 20.5C22 18.7 19.075 16.75 16 16.75ZM20.275 14.5H20.5C21.775 14.5 22.75 13.525 22.75 12.25C22.75 10.975 21.775 10 20.5 10C20.125 10 19.825 10.075 19.525 10.225C20.125 10.975 20.5 11.95 20.5 13C20.5 13.525 20.425 14.05 20.275 14.5ZM11.5 14.5H11.725C11.575 14.05 11.5 13.525 11.5 13C11.5 11.95 11.875 10.975 12.475 10.225C12.175 10.075 11.875 10 11.5 10C10.225 10 9.25 10.975 9.25 12.25C9.25 13.525 10.225 14.5 11.5 14.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12820_70741"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(7 7)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMentionsAll);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "mentions-all.15bc5b1289f81cbf6406d797265add93.svg";